//lineSplitToObject takes as an input text with new lines delimited by \n
//returns an object with the text split by line
//this can later be mapped to new lines in the react display
export function lineSplitToObject(inputText) {
  var returnArray= inputText.split("\n").map((textOfLine) => {
    var lineStyle = getLineStyle(textOfLine)
    return {
      line: lineStyle.textOfLine,
      fontSize: lineStyle.fontSize,
      fontColor: lineStyle.fontColor,
      fontWeight: lineStyle.fontWeight
    };
  })
  return returnArray
}

//get a styled line to comply with certain state requirements
//line in the database must include the following before the first character of the line that should display:
  // LINESTYLE{"fontSize": "12px", "fontColor": "red", "fontWeight": "bold"}ENDLINESTYLE
function getLineStyle(textOfLine) {
  var lineStyleObject = {fontSize:"", fontColor:"", fontWeight: ""};
  lineStyleObject.fontSize = ''
  lineStyleObject.fontColor = ''
  lineStyleObject.fontWeight = ''
  lineStyleObject.textOfLine = textOfLine
  const startChars = "LINESTYLE{"
  const endChars = "ENDLINESTYLE"
  var lineStyle = textOfLine.substring(
                              textOfLine.lastIndexOf(startChars),
                              textOfLine.lastIndexOf(endChars)
                    );
  if (lineStyle) {
    lineStyle = lineStyle.replace(startChars, "{")
    lineStyleObject = JSON.parse(lineStyle)
    lineStyleObject.textOfLine = textOfLine.substring(textOfLine.lastIndexOf(endChars) + endChars.length)
  }
  return lineStyleObject
}

export function getCreditCardFeeDisplay(creditCardFee, displayType, chargeAmount = '') {
  var creditCardFeeNote;
  const creditCardFeeList = creditCardFee.split(":");
  let txCharge = creditCardFeeList[0];
  let txChargeDisplay = '';
  let feePercent = creditCardFeeList[1];
  txCharge[0] === '.' ? (txChargeDisplay = txCharge.substr(1) + " cents") : (txChargeDisplay = "$" + txCharge);
  let feePercentDisplay = (feePercent * 100).toFixed(2) + '%';
  if (displayType === 'provider') {
    creditCardFeeNote = "The patient will be charged a credit card surcharge of " + txChargeDisplay + " + " + feePercentDisplay + " of the membership amount.";
  } else if (displayType === 'signup') {
    creditCardFeeNote = "We will apply a surcharge of " + txChargeDisplay + " + " + feePercentDisplay + " of your membership amount to your membership fee. To avoid this charge, please pay be e-check.";
  } else if (displayType === 'fee') {
    var surcharge;
    surcharge = (chargeAmount * feePercent) + parseFloat(txCharge);
    creditCardFeeNote = 'plus a $' + surcharge.toFixed(2) + ' credit card surcharge';
  }
  return creditCardFeeNote;
}